/// <amd-module name="VSSUI/Ago" />
export * from "./Components/Time/Ago/Ago";
export { IAgoProps } from "./Components/Time/Ago/Ago.Props";
